import React from 'react';
import PropTypes from 'prop-types';
import View from "react-native-web/dist/exports/View";
import StyleSheet from "react-native-web/dist/exports/StyleSheet";
import { wrapStringsInText } from '../utils';
import { useTheme, applyTextStyles } from '../ThemeProvider';
import { jsx as _jsx } from "react/jsx-runtime";
export const tokenTypes = {
  itemFontWeight: PropTypes.string.isRequired,
  itemFontSize: PropTypes.number.isRequired,
  itemLineHeight: PropTypes.number.isRequired,
  itemFontName: PropTypes.string.isRequired,
  itemFontColor: PropTypes.string
};
const selectItemTextStyles = (_ref, themeOptions) => {
  let {
    itemFontWeight,
    itemFontSize,
    itemLineHeight,
    itemFontName,
    itemFontColor,
    itemTextColor
  } = _ref;
  return applyTextStyles({
    fontColor: itemFontColor || itemTextColor,
    fontWeight: itemFontWeight,
    fontSize: itemFontSize,
    lineHeight: itemLineHeight,
    fontName: itemFontName,
    themeOptions
  });
};

/**
 * Subcomponent used within ListItem and similar components for rendering content that fills
 * and wraps available space in a { flexDirection: row } container alongside a ListIconMark,
 * and that applies text styles to strings via supplied tokens.
 *
 * It's the responsibility of themes to make sure that these text tokens align the first line of
 * text nicely against the bullet or icon rendered by ListIconMark.
 */
const ListItemContent = /*#__PURE__*/React.forwardRef((_ref2, ref) => {
  let {
    tokens,
    children
  } = _ref2;
  const {
    themeOptions
  } = useTheme();
  const textStyles = selectItemTextStyles(tokens, themeOptions);
  return /*#__PURE__*/_jsx(View, {
    style: [staticStyles.wrap, tokens?.itemUnderline && {
      textDecorationLine: tokens.itemUnderline,
      textDecorationColor: tokens.itemFontColor
    }],
    ref: ref,
    children: wrapStringsInText(children, {
      style: textStyles
    })
  });
});
ListItemContent.displayName = 'ListItemContent';
const staticStyles = StyleSheet.create({
  wrap: {
    flex: 1,
    justifyContent: 'center'
  }
});
ListItemContent.propTypes = {
  tokens: PropTypes.shape(tokenTypes).isRequired,
  children: PropTypes.node.isRequired
};
export default ListItemContent;